module.exports = __webpack_public_path__ + "static/img/player_head_13.54bf49e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_13.jpg
// module id = fe5z
// module chunks = 1